import { useState } from "react"
import { ref, push, serverTimestamp } from "../lib/firebase-database"
import { db } from "../firebase"
import { Button } from "./ui/button"
import { Textarea } from "./ui/textarea"
import { toast } from "./ui/use-toast"

export function QueryForm({ ownerEmail }) {
  const [message, setMessage] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!message.trim()) return

    setIsSubmitting(true)
    try {
      const queriesRef = ref(db, "queries")
      await push(queriesRef, {
        message,
        ownerEmail,
        status: "new",
        createdAt: serverTimestamp(),
      })

      setMessage("")
      toast({
        title: "Query submitted",
        description: "Your message has been sent to the admin.",
      })
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to send message. Please try again.",
        variant: "destructive",
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Textarea
        placeholder="Type your message to admin here..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className="min-h-[120px]"
      />
      <Button type="submit" disabled={isSubmitting || !message.trim()}>
        {isSubmitting ? "Sending..." : "Send Message"}
      </Button>
    </form>
  )
}

